import React, { useEffect } from 'react';
import { Form, Input, message, Modal } from 'antd';
import { createSkillRegistry, getSkillRegistryDetail, updateSkillRegistry, SkillRegistryVo } from '@/api/skill';

export interface EditSkillRegistryProp {
  data?: SkillRegistryVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditSkillRegistry = ({ data, isEdit, updateFn, onCancel }: EditSkillRegistryProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (isEdit && data?.id) {
      setLoading(true);
      getSkillRegistryDetail(data.id)
        .then(res => form.setFieldsValue(res))
        .finally(() => setLoading(false));
    }
  }, [data?.id, isEdit, form]);

  const onFinish = () => {
    form.validateFields().then(values => {
      const params = { ...values, id: isEdit ? data?.id : undefined };
      const api = isEdit ? updateSkillRegistry : createSkillRegistry;
      api(params as any).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑 Skill' : '新增 Skill'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Skill 名称" rules={[{ required: true, message: '请输入 Skill 名称' }]}>
          <Input placeholder="Skill 名称（唯一标识）" />
        </Form.Item>
        <Form.Item name="description" label="Skill 描述">
          <Input.TextArea rows={3} placeholder="Skill 功能描述" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditSkillRegistry;